import { MenuItem } from 'generated/graphql';
import { ItemLink } from '../../ItemLink';

type LevelFourLinkProps = {
    item: MenuItem;
};

export function LevelFourLink({ item }: LevelFourLinkProps) {
    return (
        <ItemLink
            item={item}
            buttonProps={{ sx: { marginLeft: 2 } }}
        />
    );
}
